import React, { Component } from "react";
import background from "../assets/images/background.jpg";
// Components
import TextField from "./TextField";
import CheckBox from "./CheckBox";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";

// Images import
import AddIcon from "../assets/images/add.svg";
import RemoveIcon from "../assets/images/minus.svg";
import AddBorderIcon from "../assets/images/add-border.svg";
import DeletefileIcon from "../icons/Sponser_delete";
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll';
//Validation import
import SimpleReactValidator from "simple-react-validator";
import Slider from "react-slick";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Loader import
import Loader from "./loader";
//Service import
import service from "../services";


import _ from "lodash";
import UploadForm from "./UploadForm";
import Dropdown from "./Dropdown";
import ErrorPopUp from "./errorPopUp";
import commonImage from "../commonImage";
import UploadSponser from "./UploadSponser";
import { STORAGE_PATHS } from "../cosntants";

let sub;
class AddSponsor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sponsor: "",
      loaderFlag: false,
      activeSlide: 0,
      activeSlide2: 0,
      imagePreloader: false,
      discardPopup: false,
      deleteImagePopup: false,
      getAllSponsorList: [],
      uploadFile: null,
      title: "",
      deleteImageId: "",
      deleteImagePopup: false,
      sponsordes: EditorState.createEmpty(),
      sponsorArray: [
        {
          _id: (new Date().getTime() + Math.floor(Math.random() * 10000)).toString(),
          sponsorType: "",
          image: "",
          isVisible: false,
          isEmailVisible: false,
          mobile_images: [{
            id: (new Date().getTime() + Math.floor(Math.random() * 100000)).toString(),
            url: ''
          }]
        },
      ],
      options: [
        "Presenting Sponsors",
        "Leadership Sponsors",
        "Sustaining Sponsors",
        "Media Sponsors",
        "Host State Sponsors",
        "Individuals",
        "Foundations",
        "Government Agencies",
        "Corporate Supporters",
        "Official Providers",
        "FESTIVAL HOST STATE",
        "Community Supporters",
        "Principal Sponsor",
        "Major Sponsors",
      ],
      isAddSponsorEdited: false,
      sponsorId: '',
      initialData: null
    };

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  getCurrentFormData = () => {
    const normalizeDraftHtml = (editorState) => {
        if (!editorState || typeof editorState === 'string') return '';
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
    };
    
    const description = normalizeDraftHtml(this.state.sponsordes);
    
    const sponsorArray = this.state.sponsorArray.map((item) => {
      return {
        _id: item._id,
        sponsorType: item.sponsorType,
        image: item.image,
        isVisible: item.isVisible,
        isEmailVisible: !!item.isEmailVisible,
        mobile_images: item.mobile_images ? this.ChangeTostring(item.mobile_images) : []
      };
    });

    return _.cloneDeep({
      title: this.state.title,
      description,
      sponsorArray,
    });
  }

  markAddSponsorEdited = () => {
    if (this.state.sponsorId && this.state.initialData) {
      const isDirty = !_.isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isAddSponsorEdited !== isDirty) {
        this.setState({ isAddSponsorEdited: isDirty });
      }
    }
  };

  updateState = (newState, callback) => {
    this.setState(newState, () => {
      this.markAddSponsorEdited();
      if (callback) callback();
    });
  };

  componentDidMount = async () => {
    this.getAllSponsorEvent();
    this.getAllSponsor();
    this.setState({
      loaderFlag: true,
    });
  };
  getAllSponsorEvent = () => {
    var self = this;
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "sponsor|getSponsor":
          if (!response.error && response.data.sponsorArray) {
            const blocksFromHtml = htmlToDraft(response.data.description || "");
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(
              contentBlocks,
              entityMap
            );
            const sponsordes = EditorState.createWithContent(contentState);

            const sponsorArray = response.data.sponsorArray.map((item, i) => {
              var sponsor = {
                _id: item._id,
                sponsorType: item.sponsorType,
                image: item.image,
                isVisible: item.isVisible,
                isEmailVisible: item.isEmailVisible,
                mobile_images: item.mobile_images.map((mob) => {
                  const data = {
                    id: (new Date().getTime() + Math.floor(Math.random() * 1000000)).toString(),
                    url: mob.url ? mob.url : ''
                  }
                  return data
                })
              };
              return sponsor;
            });
            this.setState({
              title: response.data.title,
              sponsorArray: sponsorArray || self.state.sponsorArray,
              sponsordes: sponsordes,
              getAllSponsor: response.data,
              sponsorId: response.data._id,
              loaderFlag: false,
            }, () => {
               this.setState({ initialData: this.getCurrentFormData(), isAddSponsorEdited: false });
            });
          } else this.setState({ loaderFlag: false });
          break;
        case "sponsor|createSponsor":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                loaderFlag: false,
                isAddSponsorEdited: false,
                sponsorId: response.data && response.data._id ? response.data._id : this.state.sponsorId,
                initialData: this.getCurrentFormData()
              },
              () => this.apiserve.success("Sponsor user created successful.")
            );
          }
          break;
      }
    });
  };

  getAllSponsor = () => {
    this.apiserve.sendevent("sponsor|getSponsor", {});
  };
  //Sponsor Push
  addSponsorFiled = (item) => {
    var newData = {
      _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
      image: "",
      sponsorType: "",
      isVisible: false,
      mobile_images: [{
        id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
        url: ''
      }]
    };
    var oldData = this.state.sponsorArray;
    oldData.push(newData);

    this.updateState({
      sponsorArray: oldData,
    });
  };

  //Sponsor Remove
  removeSponsorFiled = (i) => {
    var filteredSponsor = this.state.sponsorArray.filter((_) => _._id !== i);

    this.updateState({
      sponsorArray: filteredSponsor,
    });
  };

  onDragEnd = (result, id) => {
    if (!result.destination) {
      return;
    }

    this.state.sponsorArray.forEach((sponsorList) => {
      if (sponsorList._id === id) {
        const mobile_images = Array.from(sponsorList.mobile_images || []);
        const [removed] = mobile_images.splice(result.source.index, 1);
        mobile_images.splice(result.destination.index, 0, removed);
        sponsorList.mobile_images = mobile_images;
      }
    });

    this.setState({});
  };

  onEditorStateChange = (sponsordes) => {
    this.updateState({
      sponsordes,
    });
  };

  onChangeSponsor = (e, id) => {
    e.preventDefault();
    const { name, value } = e.target;
    this.state.sponsorArray.forEach((dataList) => {
      if (dataList._id === id) dataList[name] = value;
    });
    this.markAddSponsorEdited();
    this.setState({});
  };

  onChangeFile(e, id) {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          // file: file,
          // base64: file,
        },
        () => {
          const fileList = Math.random(file && file.size / 1024);
          if (fileList >= 2048) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload the file smaller then 2 MB",
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            setTimeout(() => {
              this.imageUpload(file, id,event.target.result);
            }, 0);
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShowL: "Please upload a file for PNG,JPG or JPEG",
            });
          }
        }
      );
    };
  }


  imageUpload = (file, id,img) => {

    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet = commonImage(file,false,'',img)

    fileSet.then((values) => {
      this.setState({
        image: values,
        imagePreloader: false,
      });
      this.state.sponsorArray.forEach((sponsorList) => {
        if (sponsorList._id === id) {
          const imagePreloaderId = `imagePreloader_${id}`;
          const newState = { ...this.state };
          newState[imagePreloaderId] = false;
          this.setState(newState);
          sponsorList.image = values;
        }
      });
      this.markAddSponsorEdited();
      this.setState({});
    });
  };

  onChangeFileImg(e, _id) {

    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.setState(
        {
          file: file,
          base64: file,
        },
        () => {
          const fileList = Math.random(file && file.size / 1024);
          if (fileList >= 2048) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload the file smaller then 2 MB",
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            setTimeout(() => {
              this.imageUploadSponser(file, _id,event.target.result);
            }, 0);
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShowL: "Please upload a file for PNG,JPG or JPEG",
            });
          }
        }
      );
    };
  }
  imageUploadSponser = (file, _id,img) => {
    this.setState({
      loaderFlag: true
    })
    const newState = { ...this.state };
    this.setState(newState);

    var fileSet = commonImage(file,false,'',img,'',STORAGE_PATHS.SPONSORS.FOOTER.ROOT +'/'+ _id?.sponsorType.toLowerCase().replace(/\s+/g, ''))
    fileSet.then((values) => {
      this.setState({
        url: values,
        imagePreloader: false,
      });

      this.state.sponsorArray.forEach((sponsorList) => {
        if (sponsorList._id === _id._id) {
          let dataa = {
            id: (new Date().getTime() + Math.floor(Math.random() * 1000)).toString(),
            url: values
          }
          sponsorList.mobile_images.push(dataa)
          this.setState({ uploadFile: null });
        }
      });

      this.markAddSponsorEdited();
      this.setState({
        loaderFlag: false
      });
    });
  };
  closeAdminUser = () => {
    this.setState({
      discardPopup: false,
      deleteImagePopup: false
    });
  };

  onChangeSpo = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  ChangeTostring = (data) => {

    let newData = data.filter(_ => _.url !== '')

    const leed = newData.map((list, i) => {

      const conv = {
        id: list.id || list._id,
        url: list.url
      }
      return conv

    })
    return leed
  }

  submitFn = async (e) => {

    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const normalizeDraftHtml = (editorState) => {
        if (!editorState || typeof editorState === "string") return "";
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        return html === "<p></p>\n" || html === "<p></p>" ? "" : html;
      };

      const markup = normalizeDraftHtml(this.state.sponsordes);
      const spon = this.state.sponsorArray.map((item, i) => {
        const data = {
          _id: item._id,
          sponsorType: item.sponsorType,
          image: item.image,
          isVisible: item.isVisible,
          isEmailVisible: item.isEmailVisible ? true : false,
          mobile_images: this.ChangeTostring(item.mobile_images)
        }
        return data
      })


      var sponsorData = {
        title: this.state.title,
        description: markup,
        sponsorArray: spon,
      };

      this.apiserve.sendevent("sponsor|createSponsor", sponsorData);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  handleTimeHours = (e) => {
    this.setState({
      options: e,
    });
  };

  handleChecked = (e, id) => {
    const { name, checked } = e.target;
    this.state.sponsorArray.forEach((dataList) => {
      if (dataList._id === id) dataList[name] = checked;
    });
    this.markAddSponsorEdited();
    this.setState({});
  };

  cancelBTN = (e) => {
    e.preventDefault();
    window.location.reload();
  };
  deleteImage(id) {

    this.setState({
      deleteImagePopup: true,
      deleteImageId: id
    }, () => {
    })


  }

  deleteImagePopup = () => {

    let newdata = this.state.sponsorArray
    if (newdata.length) {
      newdata.forEach((sponsorList) => {
        sponsorList.mobile_images.forEach((list, i) => {
          if (list.id === this.state.deleteImageId) {
            sponsorList.mobile_images.splice(i, 1);
          }
        })
      })
    }

    this.setState({
      deleteImagePopup: false,
      deleteImageId: '',
      sponsorArray: newdata
    }, () => {
      this.markAddSponsorEdited();
    })
  }
  render() {
    const { getAllSponsorList } = this.state;
    return (
      <div class="add_sponsor_sec">
        {/* Sponsers Title and Description */}
        <div class="add_sponsor_block_main">
          <div class="add_sponsor_desc_block">
            <div class="add_sponsor_main add_sponsor_main_title">
              <TextField
                type="text"
                name="title"
                label="Sponsor Title"
                value={this.state.title}
                onChange={this.onChangeSpo}
              />
            </div>

            <div class="add_sponsor_main add_sponsor_main_desc">
              <div className="form-group field_row_inner">
                <label> Sponsor Description </label>
                <div className="editor_400">

                  <Editor
                    wrapperClassName="sd_text_editor"
                    editorState={this.state.sponsordes}
                    onEditorStateChange={this.onEditorStateChange}
                    toolbar={{
                      blockType: {
                        inDropdown: true,
                        options: ['Normal', 'Blockquote'],
                      },
                      inline: { inDropdown: true },
                      list: {
                        inDropdown: true,
                        options: ['unordered', 'ordered'],
                      },
                      textAlign: { inDropdown: true },
                      link: { inDropdown: true },
                      history: { inDropdown: true },
                      options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                    }}
                    editorStyle={{ height: "250px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="add_sponsor_sec_logos">
          {this.state.sponsorArray &&
            this.state.sponsorArray.map((item, i) => {
              const imagePreloaderState = `imagePreloader_${item._id}`;
              return (
                <div class="add_sponsor_block">
                  <div class="add_sponsor_type">
                    <div class="add_sponsor_header">
                      <p>Sponsor Type</p>
                    </div>
                    <Dropdown
                      name="sponsorType"
                      value={item.sponsorType}
                      options={this.state.options}
                      onChange={(e) => this.onChangeSponsor(e, item._id)}
                    />
                    <div className="mt_10 d_flex">
                      <div>
                        <CheckBox
                          label="Show in footer"
                          type="checkbox"
                          id={item._id}
                          name="isVisible"
                          checked={item.isVisible}
                          onChange={(e) => this.handleChecked(e, item._id)}
                        />
                      </div>
                      <div className="ml_15">
                        <CheckBox
                          label="Show in email"
                          type="checkbox"
                          id={`isEmailVisible`+i}
                          name="isEmailVisible"
                          checked={item.isEmailVisible}
                          onChange={(e) => this.handleChecked(e, item._id)}
                        />
                      </div>
                    </div>
                  </div>

                  <div class="add_sponsor_image">
                    <div class="add_sponsor_header d_none">
                      <p>
                        Sponsor Logo Stack - Desktop
                        <span>
                          Use a width of 1680 px and PNG with transparent background
                        </span>
                      </p>
                    </div>

                    <div class="add_sponsor_image_box">
                      <div className="partnerLogo">
                        <div className="image_pre_loader d_none">
                          <div class="add_sponsor_img_box">
                            {this.state[imagePreloaderState] ? (
                              <Loader />
                            ) : (
                              <img
                                src={
                                  item.image
                                    ? this.apiserve.imageUrl + item.image
                                    : background
                                }
                              />
                            )}
                            <UploadForm

                              item={item}
                              handleImage={(e) =>
                                this.onChangeFile(e, item._id)
                              }
                            />
                            <span style={{ color: "red" }}>
                              {i === 0
                                ? this.validator.message(
                                  "Image",
                                  item.image,
                                  "required"
                                )
                                : ""}
                            </span>
                          </div>

                        </div>
                        <div class="add_sponsor_header1">
                          <p>
                            Sponsor Logo Stack (PNG - 300px width)
                            <span>
                              Use a width of 300 px and PNG with transparent background for each sponsor logo
                            </span>
                          </p>
                        </div>
                        <div className="d_flex">
                          <div className="sd_sponsers_Img_Slider">

                            <UploadSponser
                              item={item}
                              handleImage={(e) =>
                                this.onChangeFileImg(e, item)
                              }
                            />


                          </div>
                          <div className="sd_slider_bg">
                            <div className="sd_slick">
                              <DragDropContext onDragEnd={(result) => this.onDragEnd(result, item._id)}>
                                <Droppable droppableId={`droppable-${item._id}`} direction="horizontal">
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      style={{ display: 'flex', overflowX: 'auto', gap: '10px', paddingBottom: '10px' }}
                                    >
                                      {item.mobile_images && item.mobile_images?.map((data, index) => {
                                        const imagePreloaderState1 = `imagePreloader_${data.id}`;
                                        return (
                                          <Draggable key={data.id} draggableId={data.id} index={index}>
                                            {(provided) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="sd_slick_img"
                                                style={{
                                                  ...provided.draggableProps.style,
                                                  flexShrink: 0,
                                                  width: '150px'
                                                }}
                                              >
                                                {this.state[imagePreloaderState1] ? (
                                                  <Loader />
                                                ) : (
                                                  <img src={data.url !== '' ? this.apiserve.imageUrl + data.url : ""} />
                                                )}
                                                {data.url === '' ? (
                                                  ''
                                                ) : (
                                                  <span className="remove_file pointer" onClick={() => this.deleteImage(data.id)} ><DeletefileIcon /></span>
                                                )}
                                              </div>
                                            )}
                                          </Draggable>
                                        );
                                      })}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </div>
                          </div>

                        </div>
                      </div>




                      {i === 0 ? (
                        //  {/* For Plus Icon */}
                        <div class="add_sponsor_img_add">
                          <img
                            src={AddIcon}
                            class="add_icon"
                            onClick={() => this.addSponsorFiled(item, i)}
                          />
                          <img src={AddBorderIcon} class="add_icon_border" />
                        </div>
                      ) : (
                        <>
                          <div class="add_sponsor_img_add">
                            <img
                              src={AddIcon}
                              class="add_icon"
                              onClick={() => this.addSponsorFiled(item, i)}
                            />
                            <img src={AddBorderIcon} class="add_icon_border" />
                          </div>

                          {/* For Minus Icon */}
                          <div class="add_sponsor_img_remove">
                            <img
                              src={RemoveIcon}
                              class="remove_icon"
                              onClick={() => this.removeSponsorFiled(item._id)}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {/* </div> */}
        <div className="text_center field_row w_100 buttons_outer">
          <button
            className="uppercase"
            onClick={this.cancelBTN}
          >
            Cancel
          </button>
          <button
            className={`uppercase ${(!this.state.sponsorId || this.state.isAddSponsorEdited) ? 'active' : ''}`}
            type="button"
            disabled={this.state.loaderFlag || (this.state.sponsorId && !this.state.isAddSponsorEdited)}
            onClick={(e) => this.submitFn(e)}
          >
            Save
          </button>
        </div>
        {this.state.errorPopup ? (
          <ErrorPopUp
            errorMsg={this.state.errorMsgShow}
            errorMsgPopup={this.validateModel}
          />
        ) : (
          ""
        )}

        {this.state.deleteImagePopup ? (
          <PopUpCustomAll
            HeaderName="Delete Image?"
            insideDetails="Are You Sure ?"
            insideData="You want to delete this image"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteImagePopup}
          />
        ) : (
          ""
        )}
        {this.state.loaderFlag ? <Loader /> : ""}
      </div>
    );
  }
}
export default AddSponsor;
